import { origin } from './constant';

const UserURI = {
  loginURI: `${origin}/login`,
  logoutURI: `${origin}/logout`,
  userInfoURI: `${origin}/members/current`,
  demoLoginURI: `${origin}/guestLogin`,
};

export default UserURI;
